import { ONBOARDING_PAGE } from 'global/routes';

export const VXBOnboardingRoutes = {
  CONTACT_DETAILS: `${ONBOARDING_PAGE}/contact-details`,
  COMPLETED: `${ONBOARDING_PAGE}/completed`,
};
